import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';

import * as S from './PandaDocAnalytics.styled';
import { DATE_PRESETS, DatePresetId } from './constants';

const { RangePicker } = DatePicker;

const ISO = 'YYYY-MM-DD';

interface IDateRangeFilterProps {
  /** Active preset, or `custom` when an arbitrary range is picked. */
  preset: DatePresetId | 'custom';
  from: string | null;
  to: string | null;
  onPresetChange: (id: DatePresetId) => void;
  onCustomChange: (from: string | null, to: string | null) => void;
}

/** Quick presets plus a custom range picker — replaces the fixed 12-mo window. */
export const DateRangeFilter = memo(
  ({
    preset,
    from,
    to,
    onPresetChange,
    onCustomChange,
  }: IDateRangeFilterProps) => {
    const { t } = useTranslation();

    return (
      <S.ControlGroup>
        <S.ControlLabel>
          {t('pages.pandadocAnalytics.filters.period')}
        </S.ControlLabel>
        <S.PillGroup>
          {DATE_PRESETS.map(({ id }) => (
            <S.Pill
              key={id}
              type="button"
              active={preset === id}
              onClick={() => onPresetChange(id)}
            >
              {t(`pages.pandadocAnalytics.datePresets.${id}`)}
            </S.Pill>
          ))}
        </S.PillGroup>
        <RangePicker
          size="small"
          allowEmpty={[true, true]}
          format={ISO}
          value={[from ? moment(from, ISO) : null, to ? moment(to, ISO) : null]}
          onChange={(range) => {
            const pick = (m: Moment | null) => (m ? m.format(ISO) : null);
            onCustomChange(pick(range?.[0] ?? null), pick(range?.[1] ?? null));
          }}
        />
      </S.ControlGroup>
    );
  },
);
